module.exports = __webpack_public_path__ + "img/coin.d4d3e9bf.png";